import React from 'react';
import { motion } from 'framer-motion';
import { Link2, Zap, BarChart3, ArrowDown } from 'lucide-react';

const steps = [
  {
    number: '01',
    icon: Link2,
    title: 'Подключите свои сервисы',
    description: 'Выбирайте из 600+ готовых коннекторов. OAuth, API-ключи или прямое подключение к базе — всё поддерживается.',
    color: 'bg-[#4361ee]'
  },
  {
    number: '02',
    icon: Zap,
    title: 'Мы собираем всё остальное',
    description: 'Инфраструктура, ETL-пайплайны, модели данных — настраиваются и оптимизируются автоматически.',
    color: 'bg-[#ff6b35]'
  },
  {
    number: '03',
    icon: BarChart3,
    title: 'Получайте инсайты',
    description: 'Подключите привычный BI, спросите ИИ-ассистента или заберите данные по API. Аналитика — как вам удобно.',
    color: 'bg-[#d4ff00]'
  }
];

export default function HowItWorksSection() {
  return (
    <section className="bg-[#f5f5f0] py-24 relative overflow-hidden">
      {/* Grid background */}
      <div className="absolute inset-0 opacity-20">
        <div className="w-full h-full" style={{
          backgroundImage: `
            linear-gradient(to right, #1a1a1a 1px, transparent 1px),
            linear-gradient(to bottom, #1a1a1a 1px, transparent 1px)
          `,
          backgroundSize: '40px 40px'
        }} />
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-20"
        >
          <h2 className="text-[clamp(1.5rem,8.6vw,2.25rem)] md:text-6xl font-black text-black mb-4">
            Как это работает
          </h2>
          <p className="text-xl text-black/60 font-medium">
            От нуля до инсайтов — минуты, а не месяцы.
          </p>
        </motion.div>

        <div className="relative">
          {/* Connection line */}
          <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-1 bg-black -translate-x-1/2" />

          <div className="space-y-12 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-8">
            {steps.map((step, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.2 }}
                className="relative"
              >
                {/* Number badge */}
                <div className="absolute -top-4 -left-4 bg-black text-[#d4ff00] w-12 h-12 flex items-center justify-center font-black text-lg border-4 border-black z-10">
                  {step.number}
                </div>

                <div className="bg-white border-4 border-black p-8 pt-12 shadow-[8px_8px_0_0_#1a1a1a] h-full">
                  <div className={`w-16 h-16 ${step.color} border-4 border-black flex items-center justify-center mb-6`}>
                    <step.icon className="w-8 h-8 text-black" />
                  </div>
                  <h3 className="text-[clamp(1.125rem,5.6vw,1.5rem)] font-black text-black mb-4">{step.title}</h3>
                  <p className="text-black/70 font-medium leading-relaxed">{step.description}</p>
                </div>

                {/* Arrow between steps */}
                {i < steps.length - 1 && (
                  <div className="hidden lg:flex absolute -right-4 top-1/2 -translate-y-1/2 translate-x-full z-10">
                    <div className="bg-[#d4ff00] border-4 border-black w-8 h-8 flex items-center justify-center">
                      <ArrowDown className="w-4 h-4 text-black rotate-[-90deg]" />
                    </div>
                  </div>
                )}
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
